










































































































import {
  Vue, Prop, Component, Emit, Watch,
} from 'vue-property-decorator';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import MainButton from '@/shared/buttons/main-button.component.vue';
import CalculationErrorFilter from '@/domain/calculation/entity/calculation-error-filter.entity';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import CalculationService from '@/domain/calculation/service/calculation.service';
import Pagination from '@/domain/pagination.entity';
import CalculationError from '@/domain/calculation/entity/calculation-error.entity';
import DateHandler from '@/shared/utils/date-format';
import splitContent from '@/shared/directive/split-content';
import routeTo from '@/router/routeTo'
import FilterComponent from './billing-modal-error-filter.component.vue';
import Header from './header.json';

@Component({
  components: {
    MainButton,
    LabelSlot,
    FilterComponent,
    VbPagination,
    VbTooltipSlot,
  },
  filters: {
    formatDate(value: string) {
      return DateHandler.fullDateAndTime(value);
    },
    splitContent,
  },
})
export default class BillingModalError extends Vue {
  @Prop({
    required: true,
  })
  showModal!: boolean;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  @Prop({
    required: true,
  })
  executionError!: boolean;

  @Prop({
    required: false,
    default: true,
  })
  showContractLink?: boolean;

  @Prop({
    type: String,
    default: null,
  })
  incomingCompetence!: string;

  calculationErrors: CalculationError[] = [];

  loading: boolean = false;

  refs: any = this.$refs;

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 10,
    sortBy: [],
    defaultSort: 'createdDate|desc',
  });

  applyFilter(filter: CalculationErrorFilter) {
    this.filter = CalculationErrorFilter.of(filter);
    this.getCalculationErrors();
  }

  get header(): any[] {
    return this.showContractLink
      ? Header
      : Header.filter((el: any) => el.text !== '')
  }

  closeModal() {
    this.modalState = false;
    this.refs.filter.clear();
  }

  get modalState() {
    return this.showModal;
  }

  set modalState(value: boolean) {
    this.$emit('updateModalState', value);
  }

  goToContract(contractId: string): void {
    const route: any = {
      path: `/contract/${contractId}`,
    };
    routeTo(this.$router, route)
  }

  filter = CalculationErrorFilter.of({});

  @Watch('showModal')
  getCalculationErrors() {
    if (this.showModal) {
      if (this.executionError) {
        this.filter.recentErrors = true
        this.$emit('updateExecutionErrorState')
      }
      this.loading = true;
      CalculationService.getCalculationErrors(this.businessUnitId, this.filter,
        this.pagination.page, this.pagination.itemsPerPage)
        .then((resp: any) => {
          this.calculationErrors = CalculationError.ofList(resp.content);
          this.pagination.total = resp.totalElements;
          this.pagination.pageCount = resp.totalPages;
        }).finally(() => this.loading = false)
    }
  }

  updateTable() {
    this.pagination.verifyPage();
    this.getCalculationErrors();
  }

  created() {
    if (this.incomingCompetence) {
      this.filter.competence = this.incomingCompetence;
    }
    this.getCalculationErrors();
  }
}
